





















import Vue from 'vue';
import Component from 'vue-class-component';
import { mdiCheck } from '@mdi/js';
import { ValidationRule } from '@cnamts/vue-dot/src/rules/types';
import { disableReturn } from '@/rules/disableReturn';
import { hasTextLengthMin } from '@/rules/hasTextLengthMin';

const Props = Vue.extend({
	props: {
		commentMaxLength: {
			type: Number,
			default: 500
		},
		placeholderText: {
			type: String,
			default: ''
		},
		erreurRequiredText: {
			type: String,
			default: ''
		},
		validateEnter: {
			type: Boolean,
			default: true
		},
		rows: {
			type: Number,
			default: 3
		},
		disabled: {
			type: Boolean,
			default: false
		},
		minLength: {
			type: Number,
			default: 0
		}
	}
});

/** Comment */
@Component
export default class Comment extends Props {

	check = mdiCheck;
	textareaRules: ValidationRule[] = [];

	// Désactive le saut de ligne et assigne la fonction valider à la touche entrée
	disableReturn = [
		disableReturn(),
		(event: KeyboardEvent): void => {
			if (event.key === 'Enter' && this.validateEnter) {
				this.valider();
			}
		}
	];

	created() {
		this.getTextAreaRules();
	}

	getTextAreaRules(): void {
		this.textareaRules = [
			hasTextLengthMin(this.minLength, { default: this.erreurRequiredText })
		];
	}

	valider(): void {
		this.$emit('valider');
	}

}
